<template>
    <div>
        <!-- Modal -->
        <div id="salesBehaviorModal" class="modal fade" role="dialog">
            <div class="modal-dialog">

                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg">{{ form.name ? form.name : 'New Contact Behavior' }}</h4>
                        <button type="button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @keydown="form.errors.clear($event.target.name)">
                            <div class="mb-2">
                                <label class="text-sm text-grey-darkest -mb-0" for="name"
                                       :class="{'text-red': form.errors.has('name')}">Name</label>
                                <input v-model="form.name" id="name" name="name"
                                       class="appearance-none bg-grey-lightest border-1 focus:outline-none leading-normal px-2 rounded shadow-sm text-grey-darkest tracking-wide w-full"
                                       :class="{'border-red': form.errors.has('name')}">
                                <div class="text-red text-xs" v-if="form.errors.has('name')">{{ form.errors.get('name')
                                    }}
                                </div>
                            </div>
                            <div class="mb-2">
                                <label class="text-sm text-grey-darkest -mb-0" for="value"
                                       :class="{'text-red': form.errors.has('value')}">Value</label>
                                <input v-model="form.value" id="value" name="value" type="number"
                                       @input="form.errors.clear('value')"
                                       class="appearance-none bg-grey-lightest border-1 focus:outline-none leading-normal px-2 rounded shadow-sm text-grey-darkest tracking-wide w-full"
                                       :class="{'border-red': form.errors.has('value')}">
                                <div class="text-red text-xs" v-if="form.errors.has('value')">{{
                                    form.errors.get('value') }}
                                </div>
                            </div>
                            <div>
                                <label class="text-sm text-grey-darkest -mb-0" for="load_order"
                                    :class="{'text-red': form.errors.has('load_order')}">Load Order</label>
                                <input v-model="form.load_order" type="number" name="load_order" id="load_order"
                                    @input="form.errors.clear('load_order')"
                                    class="appearance-none bg-grey-lightest border-1 focus:outline-none leading-normal px-2 rounded shadow-sm text-grey-darkest tracking-wide w-full"
                                    :class="{'border-red': form.errors.has('load_order')}">
                                <div class="text-red text-xs" v-if="form.errors.has('load_order')">
                                    {{ form.errors.get('load_order') }}
                                </div>
                            </div>

<!--                            <div>-->
<!--                                <label class="text-sm text-grey-darkest -mb-0" for="color"-->
<!--                                       :class="{'text-red': form.errors.has('color')}">Color</label>-->
<!--                                <swatches v-model="form.color"-->
<!--                                          @input="form.errors.clear('color')"-->
<!--                                          show-fallback-->
<!--                                          colors="material-basic"-->
<!--                                          swatch-size="36"-->
<!--                                          row-length="7"-->
<!--                                          fallback-input-type="color"-->
<!--                                          fallbackOkText="Select"-->
<!--                                          fallbackOkClass="bg-followup-nav text-white p-2 rounded"-->
<!--                                          fallbackInputClass="focus:outline-none"-->
<!--                                ></swatches>-->
<!--                            </div>-->
                            <div class="flex justify-between mt-4" >
                                <div>
                                    <input type="checkbox" id="complete_comment" name="complete_comment" true-value=1 false-value=0 v-model="form.complete_comment">
                                    <label class="text-sm text-grey-darkest -mb-0" for="complete_comment"
                                           :class="{'text-red': form.errors.has('complete_comment')}">Require comment when activity is completed</label>
                                    <div class="text-red text-xs" v-if="form.errors.has('complete_comment')">{{
                                            form.errors.get('complete_comment') }}
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button @click.prevent="saved"
                                class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="data.length > 0" class="text-grey-darkest">
            <div class="text-right">
                <button data-toggle="modal" data-target="#salesBehaviorModal"
                        class="border-2 border-followup-nav focus:outline-none font-semibold hover:bg-followup-nav hover:no-underline hover:text-white material-icons p-1 rounded-full text-base text-followup-nav">
                    add
                </button>
            </div>

            <div class="bg-white shadow-md rounded mb-6 mt-1">
                <table class="text-left w-full border-collapse">
                    <thead>
                    <tr>
                        <th class="py-2 pl-4 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light">
                            Name
                        </th>
                        <th class="py-2 pl-4 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light">
                            Value
                        </th>
                        <th class="py-2 pl-4 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light">
                            Load Order
                        </th>
<!--                        <th class="py-2 pl-4 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light">-->
<!--                            Color-->
<!--                        </th>-->
                        <th class="py-2 pl-4 pr-4 bg-grey-lightest border-b border-grey-light"></th>
                    </tr>
                    </thead>
<!--                    <tbody>-->
                    <draggable
                        draggable=".item"
                        handle=".handle"
                        :list="data"
                        tag="tbody"
                        @start="drag = true"
                        @end="onUpdate"
                    >
                            <tr @click="editSalesBehavior(item)" class="hover:bg-grey-lighter cursor-pointer item handle"
                                v-for="item in data" :key="item.id">
                                <td class="pl-4 py-2 border-b border-grey-light text-xs">
                                    {{ item.name }} {{ item.proposal_delivered ? '(proposal delivered)' : '' }} {{ item.follow_up ? '(follow up)' : ''}}
                                </td>
                                <td class="pl-4 py-2 border-b border-grey-light text-xs">
                                    {{ item.value }}
                                </td>
                                <td class="pl-4 py-2 border-b border-grey-light text-xs">
                                    {{ item.load_order }}
                                </td>
<!--                                <td class="pl-4 py-2 border-b border-grey-light text-xs">-->
<!--                                    <div v-if="item.color" :style="'width:20px; height: 20px; border-radius: 50px; background-color: '+item.color+';'"></div>-->
<!--                                </td>-->
                                <td class="px-4 py-2 border-b border-grey-light text-right">
                                    <button @click.stop="editSalesBehavior(item)"
                                            class="material-icons text-base text-grey-darkest hover:text-grey-darkest focus:outline-none hover:cursor-pointer">
                                        edit
                                    </button>
                                    <button v-if="!item.proposal_delivered" @click.stop="deleteSalesBehavior(item)"
                                            class="material-icons text-base text-grey-darkest hover:text-grey-darkest focus:outline-none hover:cursor-pointer">
                                        delete
                                    </button>
                                </td>
                            </tr>
                    </draggable>
<!--                    </tbody>-->
                </table>
            </div>
        </div>
        <div v-else-if="data_loading" class="text-5xl text-grey-darkest text-center mt-32">
            <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
        </div>
        <div v-else class="mt-10 text-center">
            <div class="flex-col">
                <div>
                    <img width="400" src="/images/blank.svg">
                </div>
                <div class="mt-4">
                    <div class="text-lg text-grey-darkest mb-2 flex justify-center">
                        <div class="text-xl w-1/4 tracking-wide">You haven't created a contact behavior yet!</div>
                    </div>
                    <button @click="addSalesBehavior"
                            class="bg-followup-nav px-4 py-2 rounded-full text-white focus:outline-none hover:bg-followup-nav-darker text-xl">
                        Click here to add your first contact behavior!
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Form from "../../utils/form";
    import draggable from 'vuedraggable';
    import Swatches from 'vue-swatches';

    export default {
        name: 'sales-behaviors',

        data() {
            return {
                data: '',
                data_loading: true,
                current_sales_behavior: null,
                editing: false,
                form: new Form({
                    name: '',
                    value: '',
                    load_order: '',
                    proposal_delivered: false,
                    revised_proposal_delivered: false,
                    follow_up: false,
                    lockable_activity: false,
                    color: '',
                    complete_comment:false,
                }),
                has_proposal_delivered: false,
                has_revised_proposal_delivered: false,
                has_follow_up: false,
                has_lockable_activity: false,
            }
        },

        created() {
            this.fetchData();
        },

        mounted() {
            let self = this;
            $("#salesBehaviorModal").on('hidden.bs.modal', function () {
                self.form.reset();
                self.editing = false;
            });
        },

        methods: {
            fetchData() {
                this.data_loading = true;
                let self = this;
                axios.get(route('settings.contact-sale-behavior.index')).then(({data}) => {
                    console.log(data);
                    self.data = data.data;
                    self.data_loading = false;
                    self.has_proposal_delivered = data.hasProposalDelivered;
                    self.has_revised_proposal_delivered = data.hasRevisedProposalDelivered;
                    self.has_follow_up = data.hasFollowUp;
                    self.has_lockable_activity = data.hasLockableActivity;
                    this.onUpdate(self.data);
                });
            },

            saved() {
                let self = this;
                if (self.editing) {
                    this.form.put(route('api.settings.contact-sale-behavior.update', {salesBehavior: this.current_sales_behavior.id})).then(() => {
                        $("#salesBehaviorModal").modal("hide");
                        self.fetchData();
                    });
                } else {
                    this.form.post(route('api.settings.contact-sale-behavior.store')).then(() => {
                        $("#salesBehaviorModal").modal("hide");
                        self.fetchData();
                    });
                }
            },

            addSalesBehavior() {
                $("#salesBehaviorModal").modal("show");
                $(function () {
                    $('[data-toggle="tooltip"]').tooltip();
                });
            },

            editSalesBehavior(item) {
                $("#salesBehaviorModal").modal("show");
                $(function () {
                    $('[data-toggle="tooltip"]').tooltip();
                });

                this.current_sales_behavior = item;
                this.editing = true;
                Object.assign(this.form, item);
            },

            deleteSalesBehavior(item) {
                let self = this;
                Swal.fire({
                    title: "Are you sure?",
                    text: `You're about to delete ${item.name}. Once deleted, this contact behavior and all scheduled activities associated with this contact behavior will be deleted.`,
                    icon: "warning",
                    buttons: true,
                    dangerMode: true,
                    showCancelButton: true,
                    confirmButtonColor: '#01B1AF',
                    confirmButtonText: 'Delete Contact Behavior',
                    closeOnConfirm: false,
                    closeOnCancel: true,
                }).then((result) => {
                    if (result.value) {
                        self.form.delete(route('api.settings.contact-sale-behavior.destroy', {salesBehavior: item.id})).then(() => {
                            Swal.fire({
                                title: "Success!",
                                text: "Your contact behavior has been deleted!",
                                confirmButtonColor: '#01B1AF',
                                confirmButtonText: 'Ok!',
                                closeOnConfirm: true,
                            }).then(() => {
                                $("#salesBehaviorModal").modal("hide");
                                self.fetchData();
                            });
                        });
                    }
                });
            },

            onUpdate(item){
                let self = this;
                self.data.forEach((SaleBehavior, index) => {
                    SaleBehavior.load_order = index;
                });
                axios.put(route('settings.contact-sale-behavior.order'), this.data);
            }
        },
        components: {
            draggable,
            Swatches
        },
    }
</script>
